// EmailJS public credentials (safe to use in the browser).
// Prefer .env values when present; fallbacks keep the form working if CRA hasn't reloaded env yet.
const emailjsConfig = {
  serviceId:
    process.env.REACT_APP_EMAILJS_SERVICE_ID || "service_8b8jp0h",
  templateId:
    process.env.REACT_APP_EMAILJS_TEMPLATE_ID || "template_iyjp0sn",
  publicKey:
    process.env.REACT_APP_EMAILJS_PUBLIC_KEY || "ah8rCHyZJ3p0Px5k3",
};

export default emailjsConfig;
